import { MappedSegment, SensorInDatabaseWithTitle } from '@/utils/getFirebaseSystemByConfigId';

/**
 * This hook returns the given sensors in a layout based on some variables such as isHubFlow.
 */
export const useSensorLayout = (sensors: SensorInDatabaseWithTitle[] | undefined, isHubFlow: boolean) => {
  function getSensor(segment: MappedSegment): SensorInDatabaseWithTitle | undefined {
    return sensors?.find((sensor) => sensor.mappedSegment === segment);
  }

  if (!sensors || sensors.length === 0) return;

  if (isHubFlow) {
    return {
      left: [getSensor('leftPelvis'), getSensor('leftThigh'), getSensor('leftCalf'), getSensor('leftFoot')].filter(
        Boolean,
      ) as SensorInDatabaseWithTitle[],
      right: [getSensor('rightPelvis'), getSensor('rightThigh'), getSensor('rightCalf'), getSensor('rightFoot')].filter(
        Boolean,
      ) as SensorInDatabaseWithTitle[],
    };
  }

  return {
    left: [getSensor('leftPelvis'), getSensor('leftThigh'), getSensor('leftCalf')].filter(
      Boolean,
    ) as SensorInDatabaseWithTitle[],
    right: [getSensor('rightPelvis'), getSensor('rightThigh'), getSensor('rightCalf')].filter(
      Boolean,
    ) as SensorInDatabaseWithTitle[],
  };
};
